import React from "react";
import { CloseIcon, Flex, Image } from "@fluentui/react-northstar";
import useDialog from "../../../../hooks/useDialog";
import { ButtonGetHelp } from "../../index.style";
import { DialogOTP } from "./index.style";
import CardGuideTuto from "../../../../components/Cards/CardGuideTuto/CardGuideTuto";
import YeetchIcon from "../../../../assets/icons/logo/y.svg";
import YoutubeIcon from "../../../../assets/icons/youtube.svg";

const DialogGetHelp = () => {
    const [open, _, openDialog, closeDialog] = useDialog();
    return (
        <DialogOTP
            open={open}
            header={"Obtenir de l'aide"}
            cancelButton={{
                flat: true,
                content: "Fermer",
                fluid: true,
            }}
            content={
                <Flex fill gap="gap.large" space="around ">
                    <CardGuideTuto
                        icon={<Image src={YoutubeIcon} />}
                        content="Lancer le tutoriel"
                        fill
                    />
                    <CardGuideTuto
                        icon={<Image src={YeetchIcon} />}
                        content="Voir notre FAQ"
                    />
                </Flex>
            }
            onCancel={closeDialog}
            headerAction={{
                icon: <CloseIcon />,
                onClick: closeDialog,
            }}
            trigger={
                <ButtonGetHelp
                    onClick={openDialog}
                    text
                    content="Obtenir de l'aide"
                />
            }
        />
    );
};

export default DialogGetHelp;
